"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const subscriptionToVariant = (subscription) => {
    switch (subscription.toLowerCase()) {
        case "plus":
            return "blue";
        case "premium":
            return "yellow";
        case "vip":
            return "gray";
        case "pro":
            return "lightGray";
        default:
            return "green";
    }
};
const BaseTag = styled_components_1.default.span `
  white-space: nowrap;
  margin: 0 ${({ theme }) => theme.spacings.s};
  font-weight: normal;
  justify-content: center;
  font-size: 0.875rem;
  height: 24px;
  align-items: center;
  padding: ${({ theme }) => `0.20rem ${theme.spacings.xs}`};
  display: inline-table;

  &:last-child {
    margin-right: 0;
  }

  * {
    vertical-align: middle;
  }

  span {
    margin: 0 !important;
    padding: 0 !important;
    display: inline-block;
    &::first-letter,
    &:first-letter {
      text-transform: capitalize !important;
    }
  }

  svg {
    &:last-child {
      margin-left: ${({ theme }) => theme.spacings.xxs};
    }

    &:first-child {
      margin-right: ${({ theme }) => theme.spacings.xxs};
    }
  }
`;
const green = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.greenLighten80};
  color: ${({ theme }) => theme.colors.greenBase};
  & > * {
    color: ${({ theme }) => theme.colors.greenBase};
  }
`;
const yellow = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.yellowLighten80};
  color: ${({ theme }) => theme.colors.yellowBase};
  & > * {
    color: ${({ theme }) => theme.colors.yellowBase};
  }
`;
const red = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.pinkLighten80};
  color: ${({ theme }) => theme.colors.pinkBase};
  & > * {
    color: ${({ theme }) => theme.colors.pinkBase};
  }
`;
const blue = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.blueLighten80};
  color: ${({ theme }) => theme.colors.blueBase};
  & > * {
    color: ${({ theme }) => theme.colors.blueBase};
  }
`;
const silver = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.silverLighten70};
  color: ${({ theme }) => theme.colors.greyLighten40};
  & > * {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }
`;
const lightGray = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.silverLighten70};
  color: ${({ theme }) => theme.colors.greyLighten40};
  & > * {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }
`;
const gray = (0, styled_components_1.default)(BaseTag) `
  background-color: ${({ theme }) => theme.colors.silverLigthen50};
  color: ${({ theme }) => theme.colors.greyBase};
  & > * {
    color: ${({ theme }) => theme.colors.greyBase};
  }
`;
const blueMood = (0, styled_components_1.default)(BaseTag) `
  background-color: #acdeff;
  border-radius: ${({ theme }) => theme.utils.radiusLarge};
  color: #000105;
  & > * {
    color: #000105;
  }
`;
const redMood = (0, styled_components_1.default)(BaseTag) `
  background-color: #ffa69e;
  border-radius: ${({ theme }) => theme.utils.radiusLarge};
  color: #000105;
  & > * {
    color: #000105;
  }
`;
const greenMood = (0, styled_components_1.default)(BaseTag) `
  background-color: #9ddda0;
  border-radius: ${({ theme }) => theme.utils.radiusLarge};
  color: #000105;
  & > * {
    color: #000105;
  }
`;
const yellowMood = (0, styled_components_1.default)(BaseTag) `
  background-color: #fef29e;
  border-radius: ${({ theme }) => theme.utils.radiusLarge};
  color: #000105;
  & > * {
    color: #000105;
  }
`;
const moodColorToTag = {
    blue: blueMood,
    red: redMood,
    green: greenMood,
    yellow: yellowMood
};
const Tag = ({ variant = "green", moodVariant, subscription, children, ...props }) => {
    var _a;
    const nChildren = [];
    [children].flat(Infinity).forEach((child, i) => {
        nChildren.push(typeof child === "string" || typeof child === "number"
            ? (0, react_1.createElement)("span", { key: i }, typeof child === "string" && ["vip", "pro", "diy"].includes(child)
                ? child.toUpperCase()
                : child)
            : child);
    });
    if (moodVariant) {
        return (0, react_1.createElement)((_a = moodColorToTag[moodVariant]) !== null && _a !== void 0 ? _a : moodColorToTag.blue, props, nChildren);
    }
    return (0, react_1.createElement)({ green, red, yellow, blue, silver, gray, lightGray }[subscription ? subscriptionToVariant(subscription) : variant], props, nChildren);
};
exports.Tag = Tag;
//# sourceMappingURL=index.js.map